import $ from 'jquery';

export function backToTop(data) {
  const dom = $(`#${data.type}_${data.id}`);
  const t = dom.offset().top;
  document.documentElement.scrollTop = t;
  document.body.scrollTop = t;
  window.pageYOffset = t;
}